import Immutable from 'immutable'

import {
  FETCH_WELLNESS_REPORT,
  FETCH_WELLNESS_REPORT_SUCCESS,
  FETCH_WELLNESS_REPORT_FAILURE,
  UPDATE_SELECTED_METRIC,
  FETCH_SCAN_SNAP_DETAILS_SUCCESS,
} from '../actions/wellness/types'

// Helper function to merge scan snap data into wellness metrics.
// Skip null/undefined fields so a partial snap response doesn't clobber
// values that came from the wellness report itself.
const mergeScanSnapIntoReport = (state, scanSnapData) => {
  const report = state.get('report')
  if (!report || !scanSnapData) return state

  const updates = {}
  if (scanSnapData.vatMass != null) updates.vatMass = scanSnapData.vatMass
  if (scanSnapData.metabolicAgeYears != null) {
    updates.metabolicAgeYears = scanSnapData.metabolicAgeYears
  }
  if (Object.keys(updates).length === 0) return state

  const currentMetrics = report.get('wellnessMetrics') || Immutable.Map()
  return state.setIn(
    ['report', 'wellnessMetrics'],
    currentMetrics.merge(updates)
  )
}

const reducers = {
  [FETCH_WELLNESS_REPORT]: (state) => {
    return state.set('fetchingWellnessReport', true)
  },
  [FETCH_WELLNESS_REPORT_SUCCESS]: (state, action) => {
    let newState = state
      .set('report', Immutable.fromJS(action.payload.data))
      .set('fetchingWellnessReport', false)

    // If we already have scan snap details, merge them now
    const scanSnapData = newState.get('scanSnapData')
    if (scanSnapData) {
      newState = mergeScanSnapIntoReport(newState, scanSnapData)
    }

    return newState
  },
  [FETCH_WELLNESS_REPORT_FAILURE]: (state) =>
    state.set('fetchingWellnessReport', false),
  // [FETC]: (state) => state.set('loading', false)
  [UPDATE_SELECTED_METRIC]: (state, action) =>
    state.set('selectedMetric', action.payload),
  // Store scan snap details and merge into report (handles race condition)
  [FETCH_SCAN_SNAP_DETAILS_SUCCESS]: (state, action) => {
    const scanSnapData = action.payload.data
    if (!scanSnapData) return state

    // Store the scan snap data (now comes directly from response: { vatMass, metabolicAgeYears })
    let newState = state.set('scanSnapData', scanSnapData)

    // If report is already loaded, merge now; otherwise it will merge when report loads
    const report = newState.get('report')
    if (report) {
      newState = mergeScanSnapIntoReport(newState, scanSnapData)
    }

    return newState
  },
}

const defaultState = new Immutable.Map({
  fetchingWellnessReport: false,
  selectedMetric: null, // id of the DOM element, will enable scrolling when on wellness report page
  // records: new Immutable.List()
})

export default function (state = defaultState, action) {
  if (action && typeof reducers[action.type] === 'function') {
    // Call the given reducer from action.type with the current state
    return reducers[action.type](state, action)
  }
  // If there was no reducer function to modify state return our existing state
  return state
}
